import { useStore } from 'zustand';

import { companiesDataStore } from '../../store/companies-data-store';
import type { CompaniesDataStore } from '../../store/companies-data-store';

export const useCompanyData = <T,>(
  selector: (store: CompaniesDataStore) => T
): T => useStore(companiesDataStore, selector);
